import { render } from "./xCoolPage.vue?vue&type=template&id=13c2247b&scoped=true"
import script from "./xCoolPage.vue?vue&type=script&lang=js"
export * from "./xCoolPage.vue?vue&type=script&lang=js"

import "./xCoolPage.vue?vue&type=style&index=0&id=13c2247b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c2247b"]])

export default __exports__